import React, { useRef, useImperativeHandle, forwardRef, useEffect, useState } from 'react';
import styles from './RatioAudioPlayer.module.css';
import { HiPlay, HiPause } from 'react-icons/hi2';
import Button from '../../ui/Button';


const RatioAudioPlayer =  forwardRef(({ newseektime = undefined, tprogress = 0, culdurationn = undefined, audiodurationn, onEnded,  onSeek, onPlay, onPause, src, OnLoaded, OnSeekHandled }, ref) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(tprogress > 0 ? true : false);
  const [progress, setProgress] = useState(tprogress);
  const [duration, setDuration] = useState((audiodurationn));
  const [currentTime, setCurrentTime] = useState(0);
  const [seekTime, setSeekTime] = useState(newseektime != undefined ? newseektime : 0);
  
  const togglePlay = () => {
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
	  if(onPause)onPause();
    } else {
      audio.play();
	  if(onPlay)onPlay();
    }
    setIsPlaying(!isPlaying);
	
  };
  
  useImperativeHandle(ref, () => ({
    toggle: () => togglePlay,
	play: () => { 
    setIsPlaying(true); 
    
		var playPromise = audioRef.current?.play();

		if (playPromise !== undefined) {
			playPromise.then(_ => {
			})
			.catch(error => {
			});
		}
  
  },
    pause: () => { setIsPlaying(false); audioRef.current?.pause(); },
    load: () => audioRef.current?.load(),
    setSrc: (url) => {
      if (audioRef.current) {
        audioRef.current.src = url;
        audioRef.current.load();
      }
    },
    onEnded: (fn) => {
      //if (audioRef.current) audioRef.current.onended = fn; //(event) => { beforeOnend(fn, progress) }
    }
  }));

  useEffect(() => {
    if (audioRef.current && src) {
      audioRef.current.src = src;
      audioRef.current.load();
    }
  }, [src]);
  
 
  useEffect(() => {
		setDuration(audiodurationn);
  }, [audiodurationn]);


  useEffect(() => {
	const audio = audioRef.current;
	if(seekTime == undefined || seekTime == 0) return;
	var rduration = duration || audioRef.current.duration;
	audioRef.current.currentTime = seekTime;
	setCurrentTime(seekTime);
	setProgress(((culdurationn + audio.currentTime) / rduration) * 100);
	setSeekTime(0);
	if(OnSeekHandled)OnSeekHandled();
  }, [seekTime]);

  const handleTimeUpdate = () => {
    const audio = audioRef.current;
	var rduration = duration || audioRef.current.duration;
    if (rduration && !isNaN(rduration)) {
      setCurrentTime(audioRef.current.currentTime);
      setProgress((audio.currentTime / rduration) * 100);
	  //setProgress(Math.min((audio.currentTime / audio.duration) * 100, 100));
    }
  };
  
  const handleTimeContinueUpdate = () => {
    const audio = audioRef.current;
	var rduration = duration || audioRef.current.duration;
    if (rduration && !isNaN(rduration)) {
	  setCurrentTime(audioRef.current.currentTime);
	  setProgress(((culdurationn + audio.currentTime) / rduration) * 100);
    }
  };

  const handleLoadedMetadata = () => {
	//const audio = audioRef.current;
	var duration = audioRef.current.duration;
	if (false && duration && !isNaN(duration)) {
	  setDuration(duration);
	}
  };
  
   const handleOnEnded = () => {
	if(onEnded)onEnded(progress);
  };

  const handleSeek = (e) => {
    const rect = e.target.getBoundingClientRect();
    const seekTime = ((e.clientX - rect.left) / rect.width) * duration;
	if(onSeek != undefined) {
		var ret = onSeek(seekTime);
		setSeekTime(ret);
	}
	else {
		audioRef.current.currentTime = seekTime;
	}
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <div className={styles.player}>
      <audio
        ref={audioRef}
        src={src}
		onEnded={handleOnEnded}
        onTimeUpdate={() => {culdurationn != undefined ? handleTimeContinueUpdate() : handleTimeUpdate() }}
        onLoadedMetadata={handleLoadedMetadata} onLoadedData={OnLoaded}/>

      <Button className={styles.playButton} onClick={togglePlay}>
        {isPlaying ? <HiPause /> : <HiPlay />}
      </Button>

      <div className={styles.progressWrapper}>
        <div className={styles.progressBar} onClick={handleSeek}>
          <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        </div>
        <div className={styles.time}>
          {formatTime(culdurationn != undefined ? culdurationn + currentTime : currentTime)} / {formatTime(duration)}
        </div>
      </div>
    </div>
  );
});

export default RatioAudioPlayer;